<svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <filter x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox" id="g6y2s2hgca">
            <feGaussianBlur in="SourceGraphic"/>
        </filter>
        <filter x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox" id="j6crzcs12b">
            <feGaussianBlur in="SourceGraphic"/>
        </filter>
    </defs>
    <g filter="url(#g6y2s2hgca)" fill="none" fill-rule="evenodd">
        <circle fill="currentColor" filter="url(#j6crzcs12b)" cx="15" cy="15" r="15"/>
        <path d="m13.085 19.804-4.387-4.359a.667.667 0 0 1 0-.948l.954-.948a.678.678 0 0 1 .955 0l2.955 2.936 6.331-6.289a.678.678 0 0 1 .955 0l.954.949a.667.667 0 0 1 0 .948l-7.762 7.71a.678.678 0 0 1-.955 0z" fill="#FFF" fill-rule="nonzero"/>
    </g>
</svg>
